'use client'

import { SpeakerModalFragment } from 'generated/graphql'
import { Modal } from 'react-dialog-polyfill'
import buttonStyles from 'styles/button.module.scss'
import { FC } from 'react'

import styles from './Speaker.Modal.module.scss'

export const SpeakerModal: FC<SpeakerModalFragment & {
    open: boolean,
    updateQuery: Function,
    speakerBody: React.ReactNode
}> = ({
    forename,
    surname,
    open,
    updateQuery,
    speakerBody
}) => {

    return (
        <>
            <Modal
                id={`speaker${forename}${surname}`}
                className={styles.Modal}
                open={open}
            >
                <header>
                    <h1>{forename} {surname}</h1>
                    <button
                        onClick={ () => updateQuery("all") }
                        className={buttonStyles.Link}
                    >
                        Close
                    </button>
                </header>
                <div className={styles.ModalBody}>
                    {speakerBody}
                </div>
            </Modal>
        </>
    )
}
